// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"4e67c36b","413":"0cc030e9","423":"24e5a913","648":"c40d3047","755":"33d7046f"}[chunkId] + ".chunk.js";
};